<template>
    <div
        v-if="dashboard"
        ref="dashboard"
        class="relative min-h-full text-gray-700 flex flex-col"
        :style="dashboardBackground"
        data-cy="dashboard"
    >
        <DashboardBlock
            v-for="(item, index) in dashboard.items"
            :key="item.id"
            :item="item"
            :index="index"
            :total="dashboard.items.length"
        />
    </div>
</template>

<script setup>
    import { statusBar } from '@/services'
    import { usePlatformAuthStore } from '@/stores/platformAuth'

    const props = defineProps({
        dashboard: Object,
    })

    const platformAuthStore = usePlatformAuthStore()
    const versionStore = useVersionStore()
    const moduleHelpers = useModuleHelpers()

    const { version } = storeToRefs(versionStore)

    const dashboardBackground = computed(() => {
        if (isEmpty(props.dashboard)) {
            return {}
        }

        const background = get(props.dashboard, 'data.background_image_file')
        let color = get(props.dashboard, 'data.background_color')

        if (isEmpty(color)) {
            color = '#fff'
        }

        if (background) {
            return {
                backgroundImage: `url(${background.url})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }
        }

        return {
            backgroundColor: color,
        }
    })

    const handleLogin = () => {
        moduleHelpers.refreshInterface()
    }

    const updateStatusBar = () => {
        statusBar.setTheme(version.value.primary_color)
    }

    onMounted(() => {
        platformAuthStore.events.on('login', handleLogin)

        updateStatusBar()
    })

    onActivated(() => {
        updateStatusBar()
    })

    onUnmounted(() => {
        platformAuthStore.events.off('login', handleLogin)
    })
</script>
